import angular from 'angular'
import routers from './routers.js'
import taskTraceCtrl from './taskTraceCtrl.js'

export default angular
  .module('declaration.corporateIncomeTax.taskTrace', [])
  .config([
    '$stateProvider',
    ($stateProvider) => {
      Object.keys(routers).forEach((router) => {
        $stateProvider.state(routers[router].state, routers[router].config)
      })
    },
  ])
  .controller('taskTraceCtrl', taskTraceCtrl).name



// WEBPACK FOOTER //
// ./src/app/declaration/corporateIncomeTax/taskTrace/index.js